import Storage from './lstorage'
export default {
  filter (ctx, data) {
    return ctx.$http.post(Storage.get('serverDir') + '/board/filter', data).then(r => {
      if (r.status === 200) {
        return r.text()
      } else {
        return r.text().then(d => {
          throw d
        })
      }
    })
  },
  filterclub (ctx, data) {
    return ctx.$http.post(Storage.get('serverDir') + '/board/filterclub', data).then(r => {
      if (r.status === 200) {
        return r.text()
      } else {
        return r.text().then(d => {
          throw d
        })
      }
    })
  },
  filterall (ctx, data) {
    return ctx.$http.post(Storage.get('serverDir') + '/board/filterall', data).then(r => {
      if (r.status === 200) {
        return r.text()
      } else {
        return r.text().then(d => {
          throw d
        })
      }
    })
  },
  filterid (ctx, data) {
    return ctx.$http.post(Storage.get('serverDir') + '/board/filterid', data).then(r => {
      if (r.status === 200) {
        return r.text()
      } else {
        return r.text().then(d => {
          throw d
        })
      }
    })
  },
  addclubtogenerallessons (ctx, data) {
    return ctx.$http.post(Storage.get('serverDir') + '/board/addclubtogenerallessons', data).then(r => {
      if (r.status === 200) {
        return r.text()
      } else {
        return r.text().then(d => {
          throw d
        })
      }
    })
  },
  filterlesson (ctx, data) {
    return ctx.$http.post(Storage.get('serverDir') + '/board/filterlesson', data).then(r => {
      if (r.status === 200) {
        return r.text()
      } else {
        return r.text().then(d => {
          throw d
        })
      }
    })
  },
  /* Mucho ojo con el , y el + */
  putlesson (ctx, data) {
    return ctx.$http.post(Storage.get('serverDir') + '/board/putlesson', data).then(r => {
      if (r.status === 200) {
        return r.text()
      } else {
        return r.text().then(d => {
          throw d
        })
      }
    })
  },
  filtertorneo (ctx, data) {
    return ctx.$http.post(Storage.get('serverDir') + '/board/filtertorneo', data).then(r => {
      if (r.status === 200) {
        return r.text()
      } else {
        return r.text().then(d => {
          throw d
        })
      }
    })
  },
  stats (ctx, data) {
    return ctx.$http.get(Storage.get('serverDir') + '/board/stats' + this.urlGetParms(data)).then(r => {
      if (r.status === 200) {
        return r.text()
      } else {
        return r.text().then(d => {
          throw d
        })
      }
    })
  },
  del (ctx, data) {
    return ctx.$http.delete(Storage.get('serverDir') + '/board/del/' + data).then(r => {
      if (r.status === 200) {
        return r.text()
      } else {
        return r.text().then(d => {
          throw d
        })
      }
    })
  },
  decpos (ctx, data) {
    return ctx.$http.post(Storage.get('serverDir') + '/board/decpos/' + data).then(r => {
      if (r.status === 200) {
        return r.text()
      } else {
        return r.text().then(d => {
          throw d
        })
      }
    })
  },
  incpos (ctx, data) {
    return ctx.$http.post(Storage.get('serverDir') + '/board/incpos/' + data).then(r => {
      if (r.status === 200) {
        return r.text()
      } else {
        return r.text().then(d => {
          throw d
        })
      }
    })
  },
  urlGetParms (data) {
    var parms = '?'
    for (var key in data) {
      parms += (parms === '?' ? '' : '&') + key + '=' + data[key]
    }
    return parms
  },
  boardParms: Storage.get('parmsBoard'),
  setParms (parms) {
    this.boardParms = parms
    Storage.set('parmsBoard', parms)
  }
}




// WEBPACK FOOTER //
// ./src/services/board.js